import { jsx } from "@emotion/react/jsx-runtime";
import { FormCheckboxGroupField } from "@wsui/form";
import kebabCase from "lodash/kebabCase";
import "react";
function FormModuleRadioField(_ref) {
  let {
    field: {
      description,
      label,
      required,
      values
    },
    ...restProps
  } = _ref;
  let name = kebabCase(label);
  let options = values.map(_ref2 => {
    let {
      value
    } = _ref2;
    return value;
  });
  return /* @__PURE__ */jsx(FormCheckboxGroupField, {
    description,
    label,
    name,
    options,
    required,
    multiple: false,
    ...restProps
  });
}
export { FormModuleRadioField as default };